import { useRouter } from "next/router";
import { Fragment } from "react";
import HeaderRow from "./headerrow";
import SortTab from "./sort-tab";

export default function SortHeader({
  headertitle,
  sort,
  set_sort,
  dir,
  set_dir,
  show_random = true,
  sortarray,
}) {
  const router = useRouter();

  const randomarray = [["Random", "RAND", 0]];

  return (
    <>
      <HeaderRow
        headertitle={headertitle}
        action_condition={true}
        action_align="right"
        action={
          <>
            {/* MOBILE */}
            {sortarray?.length > 0 && (
              <div className="block sm:hidden text-sm">
                <select
                  className="cursor-pointer w-full rounded-md  text-xs
                                            bg-gray-900 border-gray-700 hover:border-gray-200
                                            "
                  value={`${sort}_${dir}`}
                  onChange={(e) => {
                    set_sort(e.target.value.split("_")[0]);
                    set_dir(e.target.value.split("_")[1]);
                  }}
                >
                  {/* SORTABLES */}
                  {sortarray?.map((e, index) => (
                    <Fragment key={index}>
                      <option value={`${e[1]}_down`}>{e[0]} &uarr;</option>
                      {e[2] == 1 && (
                        <option value={`${e[1]}_up`}>{e[0]} &darr;</option>
                      )}
                    </Fragment>
                  ))}
                  {/* RANDOM */}
                  {show_random &&
                    randomarray?.map((e, index) => (
                      <Fragment key={index}>
                        <option value={`${e[1]}_down`}>{e[0]}</option>
                      </Fragment>
                    ))}
                </select>
              </div>
            )}
            {/* DESKTOP */}
            <div className=" flex-0  hidden sm:flex items-center content-center">
              {sortarray.map((e, index) => (
                <SortTab
                  key={index}
                  sort={sort}
                  set_sort={set_sort}
                  dir={dir}
                  set_dir={set_dir}
                  e0={e[0]}
                  e1={e[1]}
                  e2={e[2]}
                  round_left={index == 0}
                  round_right={
                    show_random == false && index == sortarray.length - 1
                  }
                />
              ))}

              {show_random &&
                randomarray.map((e, index) => (
                  <SortTab
                    key={index}
                    sort={sort}
                    set_sort={set_sort}
                    dir={dir}
                    set_dir={set_dir}
                    e0={e[0]}
                    e1={e[1]}
                    e2={e[2]}
                    round_left={false}
                    round_right={index == randomarray.length - 1}
                  />
                ))}
            </div>
          </>
        }
      />
    </>
  );
}
